var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "whatsapp-glyph") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WhatsApp"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "back",
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", {
    id: "whatsApp-2",
    "data-name": "whatsApp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.64,400.05l20.25-74a142.49,142.49,0,0,1-19.06-71.37c0-78.71,64.07-142.75,142.76-142.75A142.79,142.79,0,0,1,399.36,254.82c0,78.71-64.08,142.76-142.76,142.76h-.06a142.61,142.61,0,0,1-68.22-17.38Zm79.18-45.7,4.34,2.57a118.49,118.49,0,0,0,60.39,16.54h.05c65.4,0,118.63-53.23,118.66-118.66a118.66,118.66,0,1,0-219.18,63.05l2.82,4.49-12,43.79Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.52,288.76c-.89-1.49-3.27-2.38-6.84-4.17S300.58,274.18,297.31,273s-5.65-1.79-8,1.79-9.21,11.61-11.29,14-4.16,2.68-7.73.89-15.06-5.55-28.68-17.71c-10.61-9.46-17.77-21.14-19.84-24.71s-.22-5.5,1.56-7.28c1.61-1.6,3.57-4.17,5.35-6.25a24.49,24.49,0,0,0,3.57-6,6.58,6.58,0,0,0-.3-6.25c-.89-1.79-8-19.34-11-26.48-2.89-7-5.84-6-8-6.13s-4.46-.12-6.84-.12a13.11,13.11,0,0,0-9.51,4.46c-3.27,3.57-12.48,12.2-12.48,29.76s12.78,34.52,14.57,36.9,25.15,38.41,60.94,53.86a204.73,204.73,0,0,0,20.34,7.52,48.89,48.89,0,0,0,22.46,1.41c6.86-1,21.11-8.63,24.08-17S329.41,290.25,328.52,288.76Z",
    fill: "black",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.a3cd62c6dc20f1de1302d0da9427a350.svg";
export { ForwardRef as ReactComponent };